import { useTranslation } from 'react-i18next';
import type { HumanCheck as Check } from '../../hooks/useHumanCheck';
import ui from '../../styles/ui.module.css';
import styles from './Secret.module.css';

/**
 * The Turnstile frame and a one-line status. The frame is cross-origin and
 * sandboxed: it can't read this page, navigate it, or submit its forms. It
 * stays collapsed unless Cloudflare asks the visitor to click.
 */
export default function HumanCheck({ check }: { check: Check }) {
  const { t } = useTranslation();
  const open = check.state === 'interactive';

  return (
    <div className={styles.humanCheck}>
      {check.src && (
        <iframe
          key={check.attempt}
          ref={check.frameRef}
          src={check.src}
          title={t('create.check.frameTitle')}
          className={open ? `${styles.checkFrame} ${styles.checkFrameOpen}` : styles.checkFrame}
          // Its own origin keeps it out of this page; the sandbox also stops top navigation and forms.
          // Popups are for Turnstile's privacy and help links.
          sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          referrerPolicy="no-referrer"
          tabIndex={open ? 0 : -1}
          aria-hidden={open ? undefined : true}
        />
      )}
      <p className={`${ui.hint} ${styles.checkStatus}`} aria-live="polite">
        {t(`create.check.${check.state}`)}
        {check.state === 'failed' && (
          <>
            {' '}
            <button type="button" className={styles.linkButton} onClick={check.retry}>
              {t('create.check.retry')}
            </button>
          </>
        )}
      </p>
    </div>
  );
}
